import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationVaultSandbox = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
